module.exports = __webpack_public_path__ + "src/img/projectsIcon.b483e153.png";